import React from 'react';
import DOMPurify from 'dompurify';
// for security
DOMPurify.addHook('afterSanitizeAttributes', (element) => {
    if (element instanceof HTMLAnchorElement &&
        element.target === '_blank' &&
        !element.href.startsWith(location.origin)) {
        element.setAttribute('rel', 'noopener noreferrer');
    }
});
export const RawHTML = ({ children, tag: Tag = 'span', ...props }) => (<Tag {...props} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(children, { ADD_ATTR: ['target'] }) }}/>);
export default RawHTML;
